import { createTelemetry } from "@smakecloud/browser-telemetry";
import { attachVue } from "@smakecloud/browser-telemetry/vue";
import { setSessionSlug, telemetryOptions } from "~/lib/telemetry";

/**
 * Grafana Faro: exceptions, console warn/error, web vitals, views and fetch/XHR
 * spans, redacted in the browser and again in Alloy. Off unless
 * NUXT_PUBLIC_TELEMETRY_ENABLED is set (chart: faro.enabled). Not tied to the
 * Hotjar consent: it records no sessions and no personal data.
 */
// eslint-disable-next-line no-restricted-exports
export default defineNuxtPlugin({
    name: "telemetry",
    setup(nuxtApp) {
        const options = telemetryOptions(useRuntimeConfig().public);

        if (!options) {
            return;
        }

        // created here: the Faro chunk resolves outside the Nuxt context
        const router = useRouter();
        const { slug } = storeToRefs(useSlugStore());

        // not awaited: the app does not wait for the Faro chunk
        void createTelemetry(options).then((faro) => {
            if (!faro) {
                return;
            }

            attachVue(nuxtApp, router, faro);

            // the initial route is resolved after the plugins ran
            watch(
                slug,
                (value) => {
                    setSessionSlug(faro, value);
                },
                { immediate: true },
            );
        });
    },
});
